import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate  } from "react-router-dom";
import Home from "../Home";
import { Steps, Button, Select } from "antd";
import { Modal, Spinner } from "react-bootstrap";
import Breadcrumb from "../../components/Breadcrumb";
import UltmarcRemarkLabel from "../../components/UltmarcRemarkLabel";
import { getOrganizationCustomerDetails, organizationClosure } from "./actions";
import {
  customerRequestDetails,
  resubmitChangeRequest,
  editChangeRequest,
} from "../CustomerRequestStatus/actions";
import Maintenance from "../Maintenance";

const options = [
  { value: "pption1", label: "Option 1" },
  { value: "pption2", label: "Option 2" },
  { value: "pption3", label: "Option 3" },
];

const { Step } = Steps;

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function OrganizationClosure(props) {
  const navigate = useNavigate();
  const [current, setCurrent] = React.useState(0);
  const [lang] = useTranslation("language");
  const [path, setPath] = useState("");
  const [orgId, setOrgId] = useState("");
  const [submissionType, setSubmissionType] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [unifiedCustomerCode, setUnifiedCustomerCode] = useState("");
  const [kanaFacilityName, setKanaFacilityName] = useState("");
  const [prefectureID, setPrefectureID] = useState("");
  const [cityID, setCityID] = useState("");
  const [suburbID, setSuburbID] = useState("");
  const [streetID, setStreetID] = useState("");
  const [kanjiAddressLine, setKanjiAddressLine] = useState("");
  const [kanaAddressLine, setKanaAddressLine] = useState("");
  const [managementId, setManagementId] = useState("");
  const [telephone, setTelephone] = useState("");
  const [maintenance, setMaintenance] = useState(false);
  const [postalCode, setPostalCode] = useState("");
  const [kanjiRepresentativeName, setKanjiRepresentativeName] = useState("");
  const [kanaRepresentativeName, setKanaRepresentativeName] = useState("");
  const [representativeCode, setRepresentativeCode] = useState("");
  const [kanjiPharmacistName, setKanjiPharmacistName] = useState("");
  const [kanaPharmacistName, setKanaPharmacistName] = useState("");
  const [numberOfBeds, setNumberOfBeds] = useState("");
  const [openDate, setOpenDate] = useState("");
  const [newSpecialityList, setNewSpecialityList] = useState([]);
  const [customerTypeId, setCustomerTypeId] = useState("");
  const [customerTypeName, setCustomerTypeName] = useState("");
  const [kanjiFacilityName, setKanjiFacilityName] = useState("");
  const [deleteReasonId, setDeleteReasonId] = useState("");
  const [deleteReasonName, setDeleteReasonName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [submissionId, setSubmissionId] = useState("");
  const [requestSubmissionId, setRequestSubmissionId] = useState("");
  const [acceptanceCode, setAcceptanceCode] = useState("");
  const [orgNotice, setOrgNotice] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [isScreenLoading, setIsScreenLoading] = useState(true);
  const [deleteReasonList, setDeleteReasonList] = useState([]);
  const [errors, setErrors] = useState({});
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.organizationCustomer")}`,
      path: "/organizationCustomer",
    },
    {
      name: `${lang("organizationDetails.orgCustomerChangeRequest")}`,
      path: "",
    },
  ];

  useEffect(() => {
    async function fetchData() {
      try {
        document.body.classList.add("sidebar-open");
        goBack();
        let id;
        let path;
        let pathname = window.location.pathname;
        path = unescape(pathname).split("/")[1];
        setPath(path);
        let url = window.location.href;
        id = unescape(url).split("?orgId=")[1];
        const deleteReason = sessionStorage.getItem("Planned delete reason");
        setDeleteReasonList(JSON.parse(deleteReason));
        if (path === "organizationClosure") {
          await getOrganizationCustomerDetails(id).then((res) => {
            if(res && res[0] && res[0].maintenanceWindowFlag) {
              setMaintenance(true)
            }
            setIsScreenLoading(false);
            let {
              orgCustID,
              unifiedCustomerCode,
              customerType,
              facilityNameKanji,
              remarks,
            } = res[0];
            setOrgId(orgCustID);
            setUnifiedCustomerCode(unifiedCustomerCode);
            setCustomerTypeId(customerType[0].custTypeID);
            setCustomerTypeName(customerType[0].customerTypeNameLocal);
            setKanjiFacilityName(facilityNameKanji);
            setRemarks(remarks);
          });
        } else if (
          (path ===
            "organizationClosureRequestResubmit" ||
            path === "organizationClosureRequestEdit")
        ) {
          let body = {
            id: id,
          };
          await customerRequestDetails(body).then((res) => {
        let {
          submission_id,
          submission_type,
          unified_customer_code,
          customer_id,
          customer_type,
          facility_name_kanji,
          facility_name_kana,
          management_body,
          postal_code,
          prefecture,
          city,
          suburb,
          street,
          address_line_kanji,
          address_line_kana,
          tel,
          representative_person_code,
          representative_person_name_kanji,
          representative_person_name_kana,
          supervising_person_name_kanji,
          supervising_person_name_kana,
          number_of_beds,
          planned_delete_reason,
          planned_open_date,
          specialities,
          remarks,
          ultmarc_reception_code,
          is_ultmarc_data,
        } = res.data;

        let list = [];
        specialities.value.map((sp) => list.push(sp.specialityID));
        setNewSpecialityList(list);
        setSubmissionId(
          submission_id && submission_id.value ? submission_id.value : ""
        );
        setSubmissionType(
          submission_type && submission_type.value ? submission_type.value : ""
        );
        setCustomerId(
          customer_id && customer_id.value ? customer_id.value : ""
        );
        setUnifiedCustomerCode(
          unified_customer_code && unified_customer_code.value
            ? unified_customer_code.value
            : ""
        );
        setCustomerTypeId(
          customer_type && customer_type.key ? customer_type.key : ""
        );
        setCustomerTypeName(
          customer_type && customer_type.value ? customer_type.value : ""
        );
        setKanjiFacilityName(
          facility_name_kanji && facility_name_kanji.value
            ? facility_name_kanji.value
            : ""
        );
        setKanaFacilityName(
          facility_name_kana && facility_name_kana.value
            ? facility_name_kana.value
            : ""
        );
        setManagementId(
          management_body && management_body.key ? management_body.key : ""
        );
        setPostalCode(
          postal_code && postal_code.value ? postal_code.value : ""
        );
        setPrefectureID(prefecture && prefecture.key ? prefecture.key : "");
        setCityID(city && city.key ? city.key : "");
        setSuburbID(suburb && suburb.key ? suburb.key : "");
        setStreetID(street && street.key ? street.key : "");
        setKanjiAddressLine(
          address_line_kanji && address_line_kanji.value
            ? address_line_kanji.value
            : ""
        );
        setKanaAddressLine(
          address_line_kana && address_line_kana.value
            ? address_line_kana.value
            : ""
        );
        setTelephone(tel && tel.value ? tel.value : "");
        setRepresentativeCode(
          representative_person_code && representative_person_code.value
            ? representative_person_code.value
            : ""
        );
        setKanjiPharmacistName(
          supervising_person_name_kanji && supervising_person_name_kanji.value
            ? supervising_person_name_kanji.value
            : ""
        );
        setKanaPharmacistName(
          supervising_person_name_kana && supervising_person_name_kana.value
            ? supervising_person_name_kana.value
            : ""
        );
        setKanjiRepresentativeName(
          representative_person_name_kanji &&
            representative_person_name_kanji.value
            ? representative_person_name_kanji.value
            : ""
        );
        setKanaRepresentativeName(
          representative_person_name_kana &&
            representative_person_name_kana.value
            ? representative_person_name_kana.value
            : ""
        );
        setNumberOfBeds(
          number_of_beds && number_of_beds.value ? number_of_beds.value : ""
        );
        setDeleteReasonId(
          planned_delete_reason && planned_delete_reason.key
            ? planned_delete_reason.key
            : ""
        );
        setDeleteReasonName(
          planned_delete_reason && planned_delete_reason.value
            ? planned_delete_reason.value
            : ""
        );
        setOpenDate(
          planned_open_date && planned_open_date.value
            ? planned_open_date.value
            : ""
        );
        setRemarks(remarks && remarks.value ? remarks.value : "");
        path === "organizationClosureRequestResubmit" &&
          setAcceptanceCode(
            ultmarc_reception_code &&
              ultmarc_reception_code.response_from_ultmarc
              ? ultmarc_reception_code.response_from_ultmarc
              : ""
          );
        path === "organizationClosureRequestEdit" &&
          setAcceptanceCode(
            ultmarc_reception_code && ultmarc_reception_code.value
              ? ultmarc_reception_code.value
              : ""
          );
        setIsScreenLoading(false);
      });
    }
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsScreenLoading(false);
      }
    }
    
    fetchData();
  }, []);

  useEffect(() => {
    setOrgNotice(
      props.language === "en"
        ? sessionStorage.getItem("en_org_notice")
        : sessionStorage.getItem("jp_org_notice")
    );
  }, [props.language]);

  const goBack = () => {
    setTimeout(() => {
      window.history.forward();
    }, 0);
  };

  const handleClose = () => setShow(false);

  /*** 
  @purpose : Handle delete reason
  @Parameter : {value}
  **/
  const handleDeleteReason = (value) => {
    setDeleteReasonId(value.value);
    setDeleteReasonName(value.label);
  };

  /*** 
  @purpose : Go to next step
  @Parameter : {}
  **/
  const next = () => {
    if (validateForm()) {
      setCurrent(current + 1);
    }
  };

  /*** 
  @purpose : Go to previous step
  @Parameter : {value}
  **/
  const prev = () => {
    setCurrent(current - 1);
  };

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
  @purpose : Validate org closure form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z]+|[ａ-ｚＡ-Ｚ]+[々〆〤]+/
    );
    let errors = {
      remarks: "",
    };

    if (remarks && pattern.test(remarks))
      errors.remarks = "errorMessages.VALID_REMARKS";

    if (errors.remarks) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Organization closure
  @Parameter : {value}
  **/
  const orgClosure = async () => {
    setLoading(true);
    if (path === "organizationClosure") {
      let body = {
        orgCustID: orgId,
        unified_customer_code: unifiedCustomerCode,
        customer_type: customerTypeId,
        planned_terminate_reason: deleteReasonId,
        remarks: remarks,
      };

      await organizationClosure(body).then((response) => {
        if(response.maintenanceWindowFlag) {
          setMaintenance(true)
        }
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    } else if (path === "organizationClosureRequestResubmit") {
      let body = {
        submission_id: submissionId,
        submission_data: "organization_customer",
        submission_type: submissionType,
        unified_customer_code: unifiedCustomerCode,
        customer_id: customerId ? customerId : 0,
        customer_type: customerTypeId,
        facility_name_kanji: kanjiFacilityName,
        facility_name_kana: kanaFacilityName,
        management_body: managementId,
        postal_code: postalCode,
        prefecture: prefectureID,
        city: cityID,
        street: streetID,
        suburb: suburbID,
        address_line_kanji: kanjiAddressLine,
        address_line_kana: kanaAddressLine,
        tel: telephone,
        representative_person: representativeCode,
        representative_person_name_kanji: kanjiRepresentativeName,
        representative_person_name_kana: kanaRepresentativeName,
        kanji_pharmacist_name: kanjiPharmacistName,
        kana_pharmacist_name: kanaPharmacistName,
        number_of_beds: numberOfBeds,
        planned_open_date: openDate,
        specialities: newSpecialityList,
        planned_terminate_reason: deleteReasonId,
        remarks: remarks,
        reapplication_acceptance_code: acceptanceCode,
      };
      await resubmitChangeRequest(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    } else if (path === "organizationClosureRequestEdit") {
      let body = {
        submission_id: submissionId,
        submission_data: "organization_customer",
        submission_type: submissionType,
        unified_customer_code: unifiedCustomerCode,
        customer_id: customerId ? customerId : 0,
        customer_type: customerTypeId,
        facility_name_kanji: kanjiFacilityName,
        facility_name_kana: kanaFacilityName,
        management_body: managementId,
        postal_code: postalCode,
        prefecture: prefectureID,
        city: cityID,
        street: streetID,
        suburb: suburbID,
        address_line_kanji: kanjiAddressLine,
        address_line_kana: kanaAddressLine,
        tel: telephone,
        representative_person: representativeCode,
        representative_person_name_kanji: kanjiRepresentativeName,
        representative_person_name_kana: kanaRepresentativeName,
        kanji_pharmacist_name: kanjiPharmacistName,
        kana_pharmacist_name: kanaPharmacistName,
        number_of_beds: numberOfBeds,
        planned_open_date: openDate,
        specialities: newSpecialityList,
        planned_terminate_reason: deleteReasonId,
        remarks: remarks,
        reapplication_acceptance_code: acceptanceCode,
      };
      await editChangeRequest(body).then((response) => {
        if (response.success === true) {
          setLoading(false);
          setRequestSubmissionId(response.id);
          setCurrent(current + 1);
        } else if (response.success === false) {
          setLoading(false);
          setShow(true);
        }
      });
    }
  };

  const steps = [
    {
      title: `${lang("organizationDetails.custNewChangeRequest")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-body">
              <div className="sb-row">
                <div className="sb-label">
                  {lang("customerRequestStatus.submissionType")}
                </div>
                <div className="sb-content">
                  <a href="#">{lang("errorMessages.closure")}</a>
                </div>
              </div>
              <div className="sb-row">
                <div className="sb-label">
                  {lang("customerRequestStatus.submissionData")}
                </div>
                <div className="sb-content">
                  <a href="#">
                    {lang("customerRequestStatus.organizationCustomer")}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="warning-box card">
            <div className="card-body">
              {/* <div className="warning-icon">
                <img src="images/warning.svg" alt="warning" />
              </div> */}
              {/* <h4>{lang("organizationDetails.noticeLabel")}</h4> */}
              <p>{orgNotice}</p>
            </div>
          </div>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.custNewChangeRequest")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={submissionId ? submissionId : ""}
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={unifiedCustomerCode}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={options}
                      disabled={true}
                      placeholder={customerTypeName}
                      value={customerTypeName}
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanjiFacilityName}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.plannedDeleteReason")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={deleteReasonList}
                      onChange={handleDeleteReason}
                      allowClear={deleteReasonId ? true : false}
                      value={{ value: deleteReasonId, label: deleteReasonName }}
                      showSearch={
                        deleteReasonList && deleteReasonList.length > 0
                          ? true
                          : false
                      }
                      labelInValue={true}
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label className="ultmarc-contact-note-label">
                    <UltmarcRemarkLabel />
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={remarks}
                      maxLength="200"
                      onChange={(e) => setRemarks(e.target.value)}
                    ></textarea>
                    {errors.remarks && (
                      <p className="error-text">{lang(`${errors.remarks}`)}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.reapplicationAcceptanceCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={acceptanceCode}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.confirmationLabel")}`,
      content: (
        <React.Fragment>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.confirmationLabel")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionType")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">Closure</div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionData")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("customerRequestStatus.organizationCustomer")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {submissionId ? submissionId : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {unifiedCustomerCode ? unifiedCustomerCode : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {customerTypeName ? customerTypeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiFacilityName ? kanjiFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.plannedDeleteReason")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {deleteReasonName ? deleteReasonName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label className="ultmarc-contact-note-label">
                    <UltmarcRemarkLabel />
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {remarks ? remarks : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.reapplicationAcceptanceCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label">{acceptanceCode}</div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.completedLabel")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.completedLabel")}</h4>
            </div>
            <div className="card-body">
              <p className="mb-3">
                {lang("errorMessages.REQUEST_SUBMITTED")}
                <span className="subm-title">
                  {lang("organizationDetails.submissionID")} :{" "}
                  {requestSubmissionId}
                </span>
              </p>
              <p className="mb-3">
                {lang("errorMessages.VIEW_SUBMISSION_STATUS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/customerRequestStatus");
                  }}
                >
                  {lang("Menu.customerRequestStatus")}
                </a>
              </p>
            </div>
          </div>
        </React.Fragment>
      ),
    },
  ];

  return (
    <Home>
            {maintenance ? (
        <Maintenance />
      ) : (
      <>
      <Breadcrumb routes={routes} />
      {isScreenLoading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <Steps current={current}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content horizon-form-lg">
            {steps[current].content}
          </div>
          <div className="steps-action">
            {loading && <Spinner animation="border" />}
            {current > 0 && current < 2 && (
              <Button
                style={{ margin: "0 12px" }}
                onClick={() => prev()}
                disabled={loading}
              >
                {lang("Buttons.previous")}
              </Button>
            )}
            {current < 2 && (
              <Button
                type="primary"
                onClick={() => (current < 1 ? next() : orgClosure())}
                disabled={loading}
              >
                {current < 1
                  ? `${lang("Buttons.next")}`
                  : `${lang("Buttons.submit")}`}
              </Button>
            )}
          </div>
          <Modal
            size="md"
            className="withdraw-modal"
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                {lang("errorMessages.REQUEST_NOT_SUBMITTED")}
              </div>
              <div className="buttons-group">
                <button className="btn btn-primary" onClick={handleClose}>
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
      </>)}
    </Home>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
    language: state.organizationCustomer.language,
  };
};

export default connect(mapStateToProps, { getOrganizationCustomerDetails })(
  OrganizationClosure
);
